import NextImage from 'next/image'
import cn from 'classnames'
import { STATIC_IMAGE_BASE } from '@mc/constants'
import styles from './Instructors.module.scss'

export const Instructors = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => (
  <div className='d-flex flex-column align-items-sm-center flex-sm-row flex-gap-2 flex-sm-gap-8'>
    <NextImage
      src={`${STATIC_IMAGE_BASE}/CM_instructors_hero_2x.png`}
      alt=''
      width={183}
      height={38}
      sizes='(max-width: 425px) 98px, 140px'
      className={styles.image}
    />
    <div
      style={{ maxWidth: '250px' }}
      className={cn('mc-text--balance mc-text-x-small', className)}
    >
      {children}
    </div>
  </div>
)
